import React from 'react';
import { ContentMasterySpeechRateListService } from '../../services/ContentListService';
import ContentMasteryTestSpeechRateSummary from './ContentMasteryTestSpeechRateSummary';
import { observer } from 'mobx-react';

const ContentMasteryTestSpeechRateSummaryContainer = () => {
  const summary = ContentMasterySpeechRateListService.getChart();
  return (
    <ContentMasteryTestSpeechRateSummary
      isLoading={
        ContentMasterySpeechRateListService.fetchCurrent.fetching ||
        ContentMasterySpeechRateListService.fetchPrevious.fetching
      }
      previousValue={summary.previous}
      currentValue={summary.current}
      formatter={ContentMasterySpeechRateListService.getFormattedValue}
    />
  );
};

export default observer(ContentMasteryTestSpeechRateSummaryContainer);
